import { SvgIcon, SvgIconProps } from "@mui/material";

export const ChannelsIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      aria-label="channels"
    >
      <path
        stroke="#E9946B"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M19.003 18.753V5.247a2.25 2.25 0 0 0-2.251-2.25H7.248a2.25 2.25 0 0 0-2.25 2.25v13.506a2.25 2.25 0 0 0 2.25 2.25h9.504a2.25 2.25 0 0 0 2.25-2.25Z"
        clip-rule="evenodd"
      />
      <path
        stroke="#E9946B"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M11.999 17.877a.125.125 0 1 0 .002.25.125.125 0 0 0-.002-.25"
      />
    </svg>
    ;
  </SvgIcon>
);
